export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig() as any

  // Storefronts that trimmed their public runtime config expose the flat
  // `public.environment`; the others still carry `public.service.environment`.
  const environment = config.public?.environment ?? config.public?.service?.environment

  if (config.public?.scripts?.clarity?.id && environment === 'production') {
    // Defer Clarity to not block TBT/LCP - load after interaction or 10s timeout
    nuxtApp.hook('app:mounted', () => {
      let loaded = false

      const loadClarity = () => {
        if (loaded)
          return
        loaded = true

        if (typeof requestIdleCallback !== 'undefined') {
          requestIdleCallback(() => {
            import('@microsoft/clarity').then((clarityModule) => {
              const clarity = clarityModule.default
              clarity.init(config.public.scripts.clarity.id)
              clarity.consent(true)
            })
          }, { timeout: 8000 })
        }
        else {
          setTimeout(() => {
            import('@microsoft/clarity').then((clarityModule) => {
              const clarity = clarityModule.default
              clarity.init(config.public.scripts.clarity.id)
              clarity.consent(true)
            })
          }, 5000)
        }
      }

      // Load on first user interaction or after 10s
      const events = ['click', 'scroll', 'touchstart', 'keydown']
      const handleInteraction = () => {
        loadClarity()
        events.forEach(event => window.removeEventListener(event, handleInteraction))
      }

      events.forEach(event => window.addEventListener(event, handleInteraction, { passive: true, once: true }))

      // Fallback: load after 10s if no interaction
      setTimeout(loadClarity, 10000)
    })
  }
})
